const utils = {
	/**
	 * debugMode
	 * Set to true to enable various logging capabilities throughout the application
	 */
	debugMode: true,

	/**
	 * Checks if we are in debugMode, and if so, writes a message to the console
	 * @param msg
	 * @param type
	 */
	log: function (msg, type = 'log')
	{
		const _ = this;
		if (_.debugMode) {
			switch (type) {
				case 'info':
					console.info('%c%s', 'color: cyan;', msg);
					break;
				case 'debug':
					console.debug('%c%s', 'color: grey;', msg);
					break;
				case 'warn':
					console.warn('%c%s', 'color: orange;', msg);
					break;
				case 'error':
					console.error('%c%s', 'color: red;', msg);
					break;
				default:
					console.log('%c%s', 'color: white;', msg);
					break;
			}
		}
	},

	getApiUrl: function ()
	{
		return this.getGameUrl() + '/api/v1';
	},
	getGameUrl: function ()
	{
		return document.querySelector("meta[name='app-url']").getAttribute("content");
	},
	detectIE: function ()
	{
		const ua = window.navigator.userAgent;
		const msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}
		const trident = ua.indexOf('Trident/');
		if (trident > 0) {
			const rv = ua.indexOf('rv');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}
		const edge = ua.indexOf('Edge/');
		if (edge > 0) {
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}
		return false;
	},

	/**
	 * Set variables for each element on the page
	 * @param el
	 * @returns {*}
	 */
	setEnvironment(el)
	{
		el.bearerToken = document.querySelector("meta[name='player']").getAttribute("content");
		el.gamePlayContainer = document.getElementById('cmp-game-play');
		el.questionContainer = document.getElementById('cmp-game-play__question-container');
		el.playerNameContainer = document.getElementById('cmp-game-play__name-container');
		el.truthDareBtns = document.getElementsByClassName('truth-dare-btn');
		el.dataContainer = document.getElementById('cmp-game-play__data-container');
		el.logResultsBtns = document.getElementsByClassName('log-result-btn');
		el.logResultsBtnContainer = document.getElementById('cmp-game-play__log-results-container');
		el.startTimerBtnContainer = document.getElementById('cmp-game-play__start-timer-button-container');
		el.resultFlashScreen = document.getElementById('flash-screen');
		el.scoreContainer = document.getElementById('flash-screen__play-score');
		el.flashScreenContinueButton = document.getElementById('flash-screen__continue-button');
		el.gameLevelContainer = document.getElementById('page-header__game-level');
		el.gameLevelNumberContainer = document.getElementById('page-header__game-level-number');
		el.gameLevelNameContainer = document.getElementById('page-header__game-level-name');
		el.timerContainer = document.getElementById('cmp-game-play__question-timer');
		el.timerNumber = document.getElementById('countdown-number');
		el.lowProfileMode = document.querySelector("meta[name='low-profile']").getAttribute("content");

		return el;
	},

	/**
	 * Set variables that could change with each game play. Called often throughout a game
	 * @param el
	 * @returns {*}
	 */
	setVariables(el)
	{
		el.currentPlayer = el.dataContainer.getAttribute('data-current-player');
		el.currentPlayerId = el.dataContainer.getAttribute('data-current-player-id');
		el.opponentPlayer = el.dataContainer.getAttribute('data-opponent-player');
		el.opponentPlayerId = el.dataContainer.getAttribute('data-opponent-player-id');
		el.genderTarget = el.dataContainer.getAttribute('data-gender-target');
		el.playScore = el.dataContainer.getAttribute('data-play-score');
		el.gameId = el.dataContainer.getAttribute('data-game-id');
		el.gameLevelId = el.dataContainer.getAttribute('data-game-level_id');
		el.playId = el.dataContainer.getAttribute('data-play-id');

		return el;
	},

	/**
	 * Remove or hide passed element(s) from the DOM
	 * @param elements
	 * @param action
	 */
	showHideElement(elements, action)
	{
		if (elements instanceof HTMLCollection) {
			for (const item of elements) {
				if (action === 'hide') {
					item.classList.add('hidden');
				} else {
					item.classList.remove('hidden');
				}
			}
		} else {
			if (action === 'hide') {
				elements.classList.add('hidden');
			} else {
				elements.classList.remove('hidden');
			}
		}
	},

	/**
	 * Set a pause before performing the next action
	 * @param ms
	 * @returns {Promise<unknown>}
	 */
	sleep: function (ms)
	{
		return new Promise(resolve => setTimeout(resolve, ms));
	},

	/**
	 * Add an event listener that is removed after the first use
	 * @param node
	 * @param type
	 * @param callback
	 */
	oneTimeListener: function (node, type, callback)
	{
		// create event
		node.addEventListener(type, function listener(e)
		{
			// remove event listener
			e.target.removeEventListener(e.type, listener);

			// call handler with original context
			return callback.call(this, e);
		});
	},

	/**
	 * Applies a class to animate an object out of the view, then removes the display of the object to completely hide it
	 * @param element
	 * @param animationClass
	 */
	animateAndRemove: function(element, animationClass)
	{

	},

	/**
	 * Applies a class to animate an object back into view
	 * @param element
	 * @param animationClass
	 */
	animateAndShow: function(element, animationClass)
	{
		utils.showHideElement(element, 'show');

		utils.sleep(10).then(() =>
		{
			// perform the function if more than one class is to be removed
			if(Array.isArray(animationClass))
			{
				animationClass.forEach((cssClass) => {
					element.classList.remove(cssClass)
				})
			}

			// perform the function if only one class is to be removed
			else {
				element.classList.remove(animationClass);
			}
		});
	}
}

export default utils;
